<template>
  <v-flex xs12 sm12>
    <v-card flat color="transparent">
      <v-layout row justify-center>
        <v-flex xs8 sm8 v-if="currentUser">
          <v-layout row wrap justify-center fill-height align-center>
            <v-flex xs7 style="position: relative;">
              <v-img
                class="size-image-avatar"
                :src="currentUser.image"
                :style="`border-radius: 50%; border: 5px solid `+ currentUser.color + ';'"
              >
              </v-img>
              <v-layout align-end justify-center row>
                <img
                  height="40px"
                  width="40px"
                  src="@/assets/cumple.gif"
                  v-if="currentUser.is_birthday"
                  style="position: absolute; bottom: -1rem; left: 4.4rem; "
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row mt-4>
        <v-flex xs12 sm12>
          <p class="grey-security text-xs-center font-weight-bold text-18-security mb-0"
          >{{currentUser.full_name}}</p>

          <p class="text-14-security grey-security text-xs-center mb-0"
          >{{currentUser.position}}</p>

          <p class="text-14-security grey-security font-weight-bold text-xs-center mb-0"
          >{{currentUser.company}}</p>
        </v-flex>
      </v-layout>

      <v-layout row mt-3 justify-center>
        <v-flex xs10 sm10> 
          <p class="tff-center-item text-13-security grey-security mb-0">
            <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/map-marker.svg" style="width: 17px" alt="address">
            <span class="pl-1">{{currentUser.address}}</span>
          </p>
          <p class="tff-center-item text-13-security grey-security mb-0">
            <a v-bind:href="`tel:${currentUser.phone}`" class="email_phone tff-center-item">
               <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/phone.svg" style="width: 17px" alt="phone">
              <span class="pl-1">{{currentUser.annexed}}</span>
            </a>
          </p>
          <p class="tff-center-item text-13-security grey-security mb-0">
            <a v-bind:href="`mailto:${currentUser.email}`" class="email_phone tff-center-item">
              <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/email-outline.svg"  style="width: 17px" alt="email">
              <span class="pl-1">{{ " " + currentUser.email }}</span>
            </a>
          </p>
          <p v-show="currentUser.birthday" class="tff-center-item text-13-security grey-security mb-0">
            <img  grey-security clas="colorp" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg"  style="width: 17px" alt="cake">
            <span class="pl-1">{{currentUser.birthday}}</span>
          </p>
        </v-flex>
      </v-layout>

      <v-layout row mt-4>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-btn
              color="#28385C"
              class="white--text"
              round
              @click="handleCompanyChart()"
            >
              Organigrama
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("user", ["showHideCompanyChart"]),
    handleCompanyChart() {
      this.showHideCompanyChart()
    }
  },
}
</script>

<style scoped>
.tff-center-item {
  display: flex;
  align-items: center;
}

.email_phone {
  color: #515151;
  text-decoration: inherit;
}

.size-image-avatar {
  height: 150px;
  width: 150px;
}

@media screen and (min-width: 300px) and (max-width: 325px) {
  .size-image-avatar {
    height: 130px;
    width: 130px;
  }
}
</style>